import type { CommentableContentObject, Reply } from 'models';
import { type RefObject, useMemo } from 'react';
import { useParams } from 'react-router';
import type { InputRef, RichTextEditorBase, RichTextMentions } from 'ui';
import { CommentList } from '../../comment';
import { CommentsEmpty } from '../../comments-empty';
import { type CommentMode, CreateCommentForm } from '../../create-comment-form';

type P = {
  canComment: boolean;
  canDeleteComment: (comment: Reply) => boolean;
  card?: boolean;
  commentFormContainerRef?: RefObject<HTMLDivElement | null>;
  comments: Reply[];
  contentObjectId: string;
  contentObjectType: CommentableContentObject['type'];
  createCommentForm?: boolean;
  editorRef?: RefObject<null | RichTextEditorBase>;
  initialMode?: CommentMode;
  inputRef?: RefObject<InputRef | null>;
  onRequestMentions: RichTextMentions;
};

const Comments = ({
  canComment,
  canDeleteComment,
  commentFormContainerRef,
  comments,
  contentObjectId,
  contentObjectType,
  createCommentForm = true,
  editorRef,
  initialMode,
  inputRef,
  onRequestMentions,
}: P) => {
  const topParentShareableId = useMemo(
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
    () => (comments?.[0] && 'topParentShareableId' in comments[0] ? comments[0].topParentShareableId : undefined),
    [comments],
  );

  // TODO: these should be props and useParams used in the page
  const { commentId, replyId } = useParams<{ commentId: string; replyId: string }>();

  return (
    <>
      {comments.length > 0 ? (
        <CommentList
          canComment={canComment}
          canDeleteComment={canDeleteComment}
          comments={comments}
          contentObjectId={contentObjectId}
          contentObjectType={contentObjectType}
          onRequestMentions={onRequestMentions}
          scrollToCommentId={commentId}
          scrollToReplyId={replyId}
          topParentShareableId={topParentShareableId}
        />
      ) : (
        <CommentsEmpty />
      )}
      {createCommentForm && canComment ? (
        <CreateCommentForm
          commentFormContainerRef={commentFormContainerRef}
          contentObjectId={contentObjectId}
          editorRef={editorRef}
          initialMode={initialMode}
          inputRef={inputRef}
          onRequestMentions={onRequestMentions}
        />
      ) : null}
    </>
  );
};

export default Comments;
